<template>
  <div>
    <GlobalLoader />
    <div id="page">
      <Header v-if="$route.meta.showHeader" />
      <div id="content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "./commons/Header/Header";
import GlobalLoader from "./commons/GlobalLoader/GlobalLoader";

export default {
  name: "App",
  components: {
    Header,
    GlobalLoader,
  },
  mounted() {},
};
</script>

<style lang="css">
@import "~bootstrap/dist/css/bootstrap.css";
@import "~bootstrap-vue/dist/bootstrap-vue.css";
@import "./assets/css/main.css";
@import "./assets/css/mainArtBoard.css";
@import "./assets/css/responsive.css";
@import "./assets/css/responsiveArtboard.css";
/* #page {
        direction: rtl;
    }*/
</style>
